import { Component, ChangeDetectionStrategy } from "@angular/core";

import { BoxIcon } from "@box/assets/svg";
import { IconModule } from "@box/components";
import { I18nPipe } from "@box/ui-common";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "vault-manually-open-extension",
  templateUrl: "./manually-open-extension.component.html",
  imports: [I18nPipe, IconModule],
})
export class ManuallyOpenExtensionComponent {
  protected BoxIcon = BoxIcon;
}
